// state.js
import { atom } from 'recoil';

export const bookingDataState = atom({
  key: 'bookingDataState',
  default: [], // default value (aka initial value)
});

export const selectedLevelState  = atom({
  key: 'selectedLevelState', // Unique key for the atom
  default: '1st',       // Default value
});



export const columnDefsState = atom({
  key: 'columnDefsState',
  default: [],
});
export const fetchedRowsState = atom({
  key: 'fetchedRowsState',  // Unique ID for this atom
  default: [],  // Default value is an empty array
});

// rowData atom
export const rowDataAtom = atom({
  key: 'rowDataAtom',
  default: [],  // Initialize with an empty array
});